/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */

import { ApolloLink } from '@apollo/client'
import settings from 'shared/common/settings'

export default function createLink(): ApolloLink | undefined {
  if (typeof window !== 'undefined') {
    const ActionCableLink =
      require('graphql-ruby-client/subscriptions/ActionCableLink').default
    const { createConsumer } = require('@rails/actioncable')

    return new ActionCableLink({
      cable: createConsumer(settings.getValue('API_WS_URI')),
      channelName: 'GraphqlChannel',
    })
  }

  return
}
